export const DURACELL_CLIENT_ID = 'DFCYET4FzlXAkJO';
export const PHISHCLOUD_CLIENT_ID = 'PCxK7mRvW3nTqZs';

const CID_TO_LOGIN_ROUTE_MAP = {
  [DURACELL_CLIENT_ID]: '/Duracell',
  [PHISHCLOUD_CLIENT_ID]: '/PhishCloudLogin',
};

const normalizeCid = (cid) => (typeof cid === 'string' ? cid.trim() : '');

export const getBrandedLoginRouteFromCid = (cid) => {
  const normalizedCid = normalizeCid(cid);
  return CID_TO_LOGIN_ROUTE_MAP[normalizedCid] || '';
};

export const getBrandedLoginRouteFromSearch = (search) => {
  const params = new URLSearchParams(search || '');
  const cid = params.get('cid');
  return getBrandedLoginRouteFromCid(cid);
};
